import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export default class extends Controller {
  static targets = ['emailInput', 'searchUserUrl', 'emailInputWrapper', 'foundUser', 'submitButton']

  async search () {
    const url = `${this.searchUserUrlTarget.dataset.url}?email=${this.emailInputTarget.value}`;
    const response = await get(url);
    const responseBody = await response.json

    if (responseBody.error) {
      this.showErrorMessage(responseBody)
    } else {
      this.clearErrors();
      this.showUser(responseBody)
    }
  }

  showErrorMessage(responseBody) {
    this.foundUserTarget.textContent = '';
    this.submitButtonTarget.disabled = true;

    const inputElement = this.emailInputTarget;
    const inputParent = inputElement.parentElement;

    this.emailInputWrapperTarget.classList.add('field_with_errors');

    const existingError = inputParent.nextElementSibling;

    if (existingError && existingError.classList.contains('error')) {
      existingError.textContent = responseBody.error;
    } else {
      const errorDiv = document.createElement('div');
      errorDiv.classList.add('error');
      errorDiv.textContent = responseBody.error;

      inputParent.after(errorDiv);
    }
  }

  showUser(responseBody) {
    this.submitButtonTarget.disabled = false;

    if (responseBody.user_id) {
      this.foundUserTarget.classList.add('green-text')
      this.foundUserTarget.textContent = `Wyszukany użytkownik jest możliwy do przypisania`;
      this.submitButtonTarget.textContent = "Przypisz użytkownika";
    } else {
      this.foundUserTarget.classList.remove('green-text')
      this.foundUserTarget.textContent = `Użytkownik nie został znaleziony`
      this.submitButtonTarget.textContent = "Utwórz użytkownika";
    }
  }

  clearErrors() {
    this.emailInputWrapperTarget.classList.remove('field_with_errors')

    const errorDiv = this.emailInputWrapperTarget.querySelector('.error')
    if (errorDiv) errorDiv.remove()
  }

  removeErrorOnFocus() {
    this.emailInputWrapperTarget.classList.remove('field_with_errors')

    const errorElement = this.emailInputTarget.parentElement.nextElementSibling;
    window.jQuery(errorElement).slideUp(() => { errorElement.remove() })
  }
}
